import DatabaseModel from './DatabaseModel.js';

var ClienteContacto = Object.create(DatabaseModel);

ClienteContacto.model = 'combos/clienteContactos';

export default ClienteContacto;